import { atom } from 'jotai';


const highlightsAtom = atom();

export { highlightsAtom };